import React, { useEffect } from 'react';
import {
  Container,
  StoreLogo,
  StoreInfos,
  StoreMeta,
  StoreCategoryPill,
  StoreCategory,
  StoreName,
  StoreArrow,
} from './styles';
import {ParceiroDTO} from '../../../../dtos/ParceiroDTO';
import {RFValue} from 'react-native-responsive-fontsize';
import {useNavigation} from '@react-navigation/native';
import { on } from 'events';

interface Props {
  data: ParceiroDTO;
  first?: boolean;
  horizontal?: boolean;
  asPadding?: boolean;
  verifyAccess?: boolean;
  border?: boolean;
  onClick?: () => void;
}

export function StoreItem({
  data,
  first,
  horizontal,
  verifyAccess,
  asPadding,
  border = true,
  onClick
}: Props) {
  const navigation = useNavigation();
  const parceiro = data;

  function handleNavigate() {
    if (onClick && verifyAccess) {
      onClick();
    } else {
      navigation.navigate('Store', {data});
    }
  }



  return (
    <Container
      activeOpacity={1}
      onPress={handleNavigate}
      style={{
        width: horizontal ? RFValue(220) : undefined,
        borderWidth: border ? 1 : 0,
        shadowOpacity: border ? 0.04 : 0,
        padding: border ? RFValue(12) : 0,
        backgroundColor: border ? undefined : 'transparent',
        marginTop: first || horizontal || !border ? 0 : RFValue(10),
        marginHorizontal: asPadding ? 24 : 0,
      }}>
      <StoreLogo source={{uri: parceiro.imagens.logo}} resizeMode="contain" />

      <StoreInfos>
        <StoreMeta>
          <StoreCategoryPill>
            <StoreCategory numberOfLines={1}>
              {parceiro.categoria[0].nome}
            </StoreCategory>
          </StoreCategoryPill>
        </StoreMeta>
        <StoreName numberOfLines={1} ellipsizeMode="tail">{parceiro.nome}</StoreName>
      </StoreInfos>

      <StoreArrow name="chevron-right" />
    </Container>
  );
}
